// extracted by mini-css-extract-plugin
export default {"certificate":"CertificateModal_certificate__yoyHv","certificate_img":"CertificateModal_certificate_img__ZNoA+","continue":"CertificateModal_continue__9+X5L"};